/**
 * Sticky Navigation JS controller.
 */

// Use jQuery as $ within this file scope.
const $ = jQuery;

/**
 * Class StickyNav
 */
class StickyNav {

    /**
     * Class constructor is for binding class properties.
     */
    constructor() {
        this.StickyNavHeight = 0;
    }

    /**
     * This functions is run after all script classes have been instantiated.
     * Use this if you need to access some other script instances before the document ready event.
     */
    init() {
    }

    /**
     * Cache dom elements for use in the class's methods
     */
    cache() {

        this.StickyNavContainer = $( document.getElementById( 'js-sticky-nav-container' ) );
        this.anchorLinks = $( '.js-anchor' );
    }

    /**
     * All common events
     * @return {void}
     */
    events() {

        // Check whether the product nav should be sticky every time the user scrolls the page.
        $( window ).on( 'scroll',  e => {
            this.setStickyNav( e );
        });

        // Run the initial height and top offset setting script when the window
        // is loaded to give items time to be rendered fully
        $( window ).on( 'load',  e => {
            this.initialStickyNavTop( e );
        });

        // Run the initial height and top offset setting script also when the window
        // is resized (for example on tablet orientation change). This ensures that the attribute values
        // are correct even when the nav height changes.
        $( window ).on( 'resize',  e => {
            this.initialStickyNavTop( e );
        });

        // We need to scroll the window on each anchor link click to a correct position.
        this.anchorLinks.each( ( index, anchorLink ) => {
            $( anchorLink ).on( 'click', ( e ) =>  {
                this.scrollToSection( e, anchorLink );
            });
        });
    }

    /**
     * This sets the original top offset attribute for the navigation and saves the height as well.
     * Use a small delay, so that everything (e.G. icons) is rendered before checking the height.
     */
    initialStickyNavTop() {

        setTimeout( () => {
            this.StickyNavContainer.attr( 'data-top', this.StickyNavContainer.offset().top );
            this.StickyNavHeight = this.StickyNavContainer.outerHeight();
        }, 1000 );
    }

    /**
     * This sets the navigation sticky, if the screen's top goes past the navigations top.
     * When the nav goes sticky, body gets the nav's height as top margin so that the content doesn't hop up.
     * If the user scrolls back up, reset everything.
     */
    setStickyNav() {

        if ( $( window ).scrollTop() > this.StickyNavContainer.attr( 'data-top' ) ) {
            this.StickyNavContainer.addClass( 'js-sticky' );
            document.body.style.margin = this.StickyNavHeight + 'px 0px 0px 0px';
        } else {
            this.StickyNavContainer.removeClass( 'js-sticky' );
            document.body.style.margin = '0px';
        }
    }

    /**
     * Stop the link default behaviour and scroll the window to the given target's top edge.
     * Add an additional offset from the sticky navigation's height and a few pixels to cover the
     * scrolling offset entirely.
     *
     * @param {event} e
     * @param {object} anchorLink
     */
    scrollToSection( e, anchorLink ) {
        Theme.Common.stop( e );
        const scrollTarget = $( '#' + $( anchorLink ).attr( 'data-target' ) );
        const scrollTargetTop = scrollTarget.offset().top - this.StickyNavHeight + 5;
        $( 'html,body' ).scrollTop( scrollTargetTop );
    }

    /**
     * Run when the document is ready.
     */
    docReady() {
        this.cache();
        this.events();
    }
}

// Export the class reference.
module.exports = StickyNav;



// WEBPACK FOOTER //
// ./assets/scripts/sticky-nav.js